export const COMPLIANCE_TYPE = {
  DETAILED_FINDING: 'detailedFinding',
  LEGAL_REQUIREMENTS: 'legalRequirements',
  RECOMMENDATIONS: 'recommendations',
  CORRECTIVE_ACTION_TAKEN: 'correctiveActionTaken',
};

export const RESULT_TYPE = {
  CHECKLIST: 'CHECKLIST',
  DATASHEET: 'DATASHEET',
};
